import { Card, CardHeader, Table, Container, Row, Button } from "reactstrap";
import Header from "components/Headers/Header.js";
import { useEffect, useState } from "react";
import axios from "axios";
import CreaTaller from "views/Crea/CreaTaller";
import EditaTaller from "./EditarTaller";
import ProtectedRoute from "./Protected";

const Talleres = () => {
  const [list1, setList1] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [tallerSeleccionado, setTallerSeleccionado] = useState(null);

  const urlendpoint =
    "https://inspecciongnvback.azurewebsites.net/api/v1/ObtenerTalleres";

  const obtenerTalleres = () => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((Response) => {
        setList1(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    obtenerTalleres();
  }, []);

  const abrirModalEditar = (taller) => {
    setTallerSeleccionado(taller);
    setModalOpen(true);
  };

  return (
    <ProtectedRoute>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mt-5">
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0">
                <h3 className="text-white mb-0">Taller</h3>
              </CardHeader>
              <div className="text-center">
                <CreaTaller actualizar={obtenerTalleres} />
              </div>
              <Table
                className="align-items-center table-dark table-flush"
                responsive
              >
                <thead className="thead-dark">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Nit</th>
                    <th scope="col">Sucursal</th>
                    <th scope="col">Nombre Taller</th>
                    <th scope="col">Dirección</th>
                    <th scope="col">Teléfono</th>
                    <th scope="col">Certificado</th>
                    <th scope="col">Emitido</th>
                    <th scope="col">Emisión</th>
                    <th scope="col">Vencimiento</th>
                    <th scope="col">Póliza</th>
                    <th scope="col">Vigencia Política</th>
                    <th scope="col">Chip Validador</th>
                    <th scope="col">Chip Tanqueo</th>
                    <th scope="col">Fecha vence legal</th>
                    <th scope="col">Técnicos</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Regional</th>
                    <th scope="col">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {list1.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nit}</td>
                      <td>{item.sucursal}</td>
                      <td>{item.nombreTaller}</td>
                      <td>{item.direccion}</td>
                      <td>{item.telefono}</td>
                      <td>{item.numeroCertificado}</td>
                      <td>{item.emitido}</td>
                      <td>{item.fechaEmision}</td>
                      <td>{item.fechaVencimiento}</td>
                      <td>{item.polizaResponsableCivil}</td>
                      <td>{item.ultimaVigenciaPoliticaDL}</td>
                      <td>{item.idRomChipValidador}</td>
                      <td>{item.chipTanqueo}</td>
                      <td>{item.fechaVenceLegales}</td>
                      <td>{item.numeroTecnicos}</td>
                      <td>{item.estado}</td>
                      <td>{item.regionalId}</td>
                      <td>
                        <Button
                          color="warning"
                          size="sm"
                          onClick={() => abrirModalEditar(item)}
                        >
                          Editar
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>

        {/* Modal único */}
        {tallerSeleccionado && (
          <EditaTaller
            isOpen={modalOpen}
            toggle={() => setModalOpen(!modalOpen)}
            taller={tallerSeleccionado}
            actualizar={obtenerTalleres}
          />
        )}
      </Container>
    </ProtectedRoute>
  );
};

export default Talleres;
